var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.688 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.344,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0h0 0L0 13.28l5.72 49.24L37.5 80h0 0l31.78-17.48L75 13.28z",
    fill: "#dd0031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 0v8.88-.04 40.52h0V80h0l31.78-17.48L75 13.28 37.5 0z",
    fill: "#c3002f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.501 8.84l-23.443 52.2h0 8.741 0l4.713-11.68h19.898l4.713 11.68h0 8.741 0L37.501 8.84h0 0 0 0zm6.847 33.32H30.653l6.847-16.36 6.847 16.36z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.48aae77e0bae93aba784430b71c8c627.svg";
export { ForwardRef as ReactComponent };